import { useTranslation } from "react-i18next";

import { Handbook } from "features/handbook/model/handbook";
import { fmt } from "./handbookColumns";
import { HandbookColumn } from "./handbookColumns.types";
import { HandbookRowActions } from "./HandbookRowActions";
import styles from "./HandbookTable.module.css";

type Props = {
  row: Handbook;
  index: number;
  columns: HandbookColumn[];
  isAttached: boolean;
  showActionButtons: boolean;
  showAttachButton?: boolean;
  onAttachToService?: (row: Handbook) => void;
  showDetachButton?: boolean;
  onDetachFromService?: (row: Handbook) => void;
  onEdit?: (row: Handbook) => void;
  onDelete?: (row: Handbook) => void;
};

export const HandbookTableRow = ({
  row,
  index,
  columns,
  isAttached,
  showActionButtons,
  ...actions
}: Props) => {
  const { t } = useTranslation();

  return (
    <tr className={`${styles.row} ${isAttached ? styles.attachedRow : ""}`}>
      <td data-label="№" className={styles.indexCell}>
        {index}
      </td>
      <td data-label={t("handbook.table.nameRu")}>{fmt(row.nameRu)}</td>
      <td data-label={t("handbook.table.nameKy")}>{fmt(row.nameKy)}</td>

      {columns.map((column) => (
        <td
          key={column.key}
          data-label={column.label ?? column.header}
          style={column.cellStyle}
        >
          {column.render(row)}
        </td>
      ))}

      {/* Текстовые действия — мобилка */}
      <td data-label={t("handbook.table.action")} className={styles.textActions}>
        <div className={styles.textAction}>{t("handbook.table.edit")}</div>
        <div className={styles.textActionDanger}>
          {t("handbook.table.delete")}
        </div>
      </td>

      {/* Кнопки действий — десктоп */}
      {showActionButtons && (
        <td className={styles.btnActions}>
          <HandbookRowActions row={row} isAttached={isAttached} {...actions} />
        </td>
      )}
    </tr>
  );
};
